import { useAuth0 } from '@auth0/auth0-react';
import Dialog from '@material-ui/core/Dialog';
import FacebookIcon from "assets/icons/facebook-link.svg";
import instagramIcon from "assets/icons/instagram-link.svg";
import twitterIcon from "assets/icons/twitter-link.svg";
import { InputField, InputFieldWithCheckbox, LabelField, MyCheckbox, SelectField } from 'components';
import InfoTooltip from 'components/InfoTooltip';
import FindMyCity from 'components/FindMyCity';
import AddNewTag from "pages/Members/MemberDetails/AddNewTag";
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { toastr } from 'react-redux-toastr';
import { fontConfig } from "theme/fontConfig";

const ClassDetails = ({ formik }) => {
  const { getAccessTokenSilently } = useAuth0();


  const [openTag, setOpenTag] = useState(false);
  const [openAccountTag, setOpenAccountTag] = useState(false);
  const [deleteTagConfirm, setDeleteTagConfirm] = useState(false);
  const [tagToDelete, setTagToDelete] = useState(null);

  const handleActiveGender = (eventType) => {
    formik.setFieldValue('eventDetails.eventType', eventType);
  };

  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  const deleteTag = async (tag) => {
    formik.setFieldValue(
      'eventDetails.tags',
      formik.values?.eventDetails?.tags?.filter((item) => item !== tag)
    );
  };

  const addressHandleChange = async (address) => {
    formik.setFieldValue(`eventDetails.eventAddress`, {
      formattedAddress: address?.label,
      place_id: address?.value?.place_id || null,
    });
  };

  const resetTicketVariantQuantity = () => {
    const prices = formik.values?.prices;
    if (!prices?.length) return;
    // update infiniteQuantity inside each item inside variantInfo inside prices
    const updatedPrices = prices.map((price) => {
      const updatedVariantInfo = price?.variantInfo.map((variant) => {
        return {
          ...variant,
          infiniteQuantity: false,
        };
      });
      return {
        ...price,
        variantInfo: updatedVariantInfo,
      };
    });
    formik.setFieldValue('prices', updatedPrices);
  };


  return (
    <>
      <Row style={{ marginBottom: '40px' }}>
        {!formik.values?.displayOnly && <Col className="col-sm-6">
          <InputFieldWithCheckbox
            titleStyle={{
              fontFamily: fontConfig.EventsInputFieldWithCheckboxFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            formik={formik}
            mandatory={false}
            title={
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                Maximum Capacity
                {!formik.values?.eventDetails?.infiniteCapacity && <span style={{ color: 'red' }}>*</span>}
                <InfoTooltip text="Set the maximum number of attendees allowed to register. Once the limit is reached, registration closes automatically. E.g., A venue that seats 100 people. Check 'No Limit' for unlimited registrations." useFixed />
              </span>
            }
            name="eventDetails.maximumCapacity"
            placeholder="Maximum Capacity"
            checkValidation={true}
            handleChange={(e) => {
              const value = e?.target?.value.match(regex)[0];
              const intValue = parseInt(value) > 0 ? parseInt(value) : '';
              if (intValue > 10000) return;
              formik.setFieldValue('eventDetails.maximumCapacity', intValue);
            }}
            value={formik.values?.eventDetails?.maximumCapacity}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
            onBlur={formik.handleBlur}
            disabled={formik.values?.eventDetails?.infiniteCapacity}
            checkbox={"eventDetails.infiniteCapacity"}
            checkedBox={formik.values?.eventDetails?.infiniteCapacity}
            checkboxLabel={"No Limit"}
            checkboxChange={(e) => {
              if (e?.target?.checked) {
                formik.setFieldValue('eventDetails.maximumCapacity', '');
                formik.setFieldTouched('eventDetails.maximumCapacity', false);
              }
              formik.setFieldValue(
                'eventDetails.infiniteCapacity',
                !formik.values?.eventDetails?.infiniteCapacity
              ).then(() => formik.validateForm());
              resetTicketVariantQuantity();
            }}
          />
        </Col>}
        <Col className="col-sm-6">
          <LabelField
            title="Event Type"
            style={{
              fontFamily: fontConfig.GeneralLabelFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
          />
          <div className="gender_container">
            <div
              onClick={() => handleActiveGender('In-Person')}
              className={
                formik.values?.eventDetails?.eventType === 'In-Person'
                  ? 'gender genderActive'
                  : 'gender'
              }
            >
              In-Person
            </div>
            <div
              onClick={() => handleActiveGender('online')}
              className={
                formik.values?.eventDetails?.eventType === 'online'
                  ? 'gender genderActive'
                  : 'gender'
              }
            >
              Online
            </div>
            <div
              onClick={() => handleActiveGender('In-Person & Online')}
              className={
                formik.values?.eventDetails?.eventType === 'In-Person & Online'
                  ? 'gender genderActive'
                  : 'gender'
              }
            >
              In-Person & Online
            </div>
          </div>
        </Col>
      </Row>
      <hr />
      <Row style={{ marginBottom: '40px' }}>
        <Col className="col-sm-12">
          <FindMyCity
            handleChange={(data) =>
              addressHandleChange(data)
            }
            title="Event Address"
            titleStyles={{
              fontFamily: fontConfig.EventsFindMyCityFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            value={{
              label: formik.values?.eventDetails?.eventAddress?.formattedAddress || "Event Address",
              value: formik.values?.eventDetails?.eventAddress?.place_id || "",
            }}
            copy={true}
            saveNewAddress={true}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: '40px' }}>
        <Col className="col-sm-12">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            mandatory={false}
            {...{
              formik,
              title: 'Event link',
              name: 'eventLink',
              placeholder: 'Event link',
              checkValidation: true,
            }}
            value={formik.values?.eventDetails?.eventLink}
            handleChange={(e) => {
              formik.setFieldValue('eventDetails.eventLink', e.target?.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.eventDetails?.eventLink === '') {
                e.preventDefault();
              }
            }}
          />
        </Col>
      </Row>
      <hr />
      <Row style={{ marginBottom: '40px' }}>
        <Col className="col-sm-12">
          <LabelField
            title="Contact Info"
            style={{
              fontSize: "12px",
              color: "#002E5C",
              opacity: "0.7",

            }}
            className="contact-info-label"
          />
        </Col>
        <Col className="col-sm-6">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            mandatory={false}
            {...{
              formik,
              title: 'First Name',
              name: 'firstName',
              placeholder: 'First Name',
              checkValidation: true,
            }}
            maxLength={50}
            value={formik.values?.eventDetails?.contactInfo?.firstName}
            handleChange={(e) => {
              formik.setFieldValue('eventDetails.contactInfo.firstName', e.target?.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.eventDetails?.contactInfo?.firstName === '') {
                e.preventDefault();
              }
            }}
          />
        </Col>
        <Col className="col-sm-6">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            mandatory={false}
            {...{
              formik,
              title: 'Last Name',
              name: 'lastName',
              placeholder: 'Last Name',
              checkValidation: true,
            }}
            maxLength={50}
            value={formik.values?.eventDetails?.contactInfo?.lastName}
            handleChange={(e) => {
              formik.setFieldValue('eventDetails.contactInfo.lastName', e.target?.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.eventDetails?.contactInfo?.lastName === '') {
                e.preventDefault();
              }
            }}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: '40px' }}>
        <Col className="col-sm-6">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            mandatory={true}
            {...{
              formik,
              title: 'Email',
              name: 'eventDetails.contactInfo.email',
              placeholder: 'Email',
              checkValidation: true,
              copy: true,
            }}
            maxLength={80}
            value={formik.values?.eventDetails?.contactInfo?.email}
            handleChange={(e) => {
              formik.setFieldValue('eventDetails.contactInfo.email', e.target?.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.eventDetails?.contactInfo?.email === '') {
                e.preventDefault();
              }
            }}
            onBlur={formik.handleBlur}
          />
        </Col>
        <Col className="col-sm-6" style={{ marginTop: '40px' }}>
          <MyCheckbox
            title="Show my email"
            checked={formik.values?.eventDetails?.contactInfo?.showEmail}
            handlechange={() => {
              formik.setFieldValue(
                'eventDetails.contactInfo.showEmail',
                !formik.values?.eventDetails?.contactInfo?.showEmail
              );
            }}
            titleStyles={{
              fontSize: "12px"
            }}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: '40px' }}>
        <Col className="col-sm-6">
          <div className="d-flex align-items-center" style={{
            gap: "5px"
          }}>
            <img src={FacebookIcon}
              style={{ marginBottom: '0.75rem' }}
              alt="Facebook"
            />
            <LabelField
              mandatory={false}
              style={{
                fontFamily: fontConfig.GeneralLabelFieldFont.family,
                fontWeight: '400',
                fontSize: '12px',
                lineHeight: '18px',
                color: '#4F4F4F',
              }}
            >
              Facebook <span className="label__sub-title">(Optional)</span>
            </LabelField>
          </div>
          <InputField
            {...{
              formik,
              title: 'none',
              name: 'facebook',
              placeholder: 'Enter Link',
              checkValidation: true,
              formStyle: {
                marginBottom: '0px',
              }
            }}
            value={formik.values?.eventDetails?.contactInfo?.facebook}
            handleChange={(e) => {
              formik.setFieldValue('eventDetails.contactInfo.facebook', e.target?.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.eventDetails?.contactInfo?.facebook === '') {
                e.preventDefault();
              }
            }}
          />
        </Col>
        <Col className="col-sm-6">
          <div className="d-flex align-items-center" style={{
            gap: "5px"
          }}>
            <img src={instagramIcon}
              style={{ marginBottom: '0.75rem' }}
              alt="Instagram"
            />
            <LabelField
              mandatory={false}
              style={{
                fontFamily: fontConfig.GeneralLabelFieldFont.family,
                fontWeight: '400',
                fontSize: '12px',
                lineHeight: '18px',
                color: '#4F4F4F',
              }}
            >
              Instagram <span className="label__sub-title">(Optional)</span>
            </LabelField>
          </div>
          <InputField
            {...{
              formik,
              title: 'none',
              name: 'instagram',
              placeholder: 'Enter Link',
              checkValidation: true,
              formStyle: {
                marginBottom: '0px',
              }
            }}
            value={formik.values?.eventDetails?.contactInfo?.instagram}
            handleChange={(e) => {
              formik.setFieldValue('eventDetails.contactInfo.instagram', e.target?.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.eventDetails?.contactInfo?.instagram === '') {
                e.preventDefault();
              }
            }}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: '40px' }}>
        <Col className="col-sm-6">
          <div className="d-flex align-items-center" style={{
            gap: "5px"
          }}>
            <img src={twitterIcon}
              style={{ marginBottom: '0.75rem' }}
              alt="Twitter"
            />
            <LabelField
              mandatory={false}
              style={{
                fontFamily: fontConfig.GeneralLabelFieldFont.family,
                fontWeight: '400',
                fontSize: '12px',
                lineHeight: '18px',
                color: '#4F4F4F',
              }}
            >
              X <span className="label__sub-title">(Optional)</span>
            </LabelField>
          </div>
          <InputField
            {...{
              formik,
              title: 'none',
              name: 'twitter',
              placeholder: 'Enter Link',
              checkValidation: true,
              formStyle: {
                marginBottom: '0px',
              }
            }}
            value={formik.values?.eventDetails?.contactInfo?.twitter}
            handleChange={(e) => {
              formik.setFieldValue('eventDetails.contactInfo.twitter', e.target?.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.eventDetails?.contactInfo?.twitter === '') {
                e.preventDefault();
              }
            }}
          />
        </Col>
      </Row>
      {!formik.values?.displayOnly && <>
        <hr />
        <Row style={{ marginBottom: '40px' }}>
          <Col className="col-sm-12">
            <div className="d-flex" style={{ gap: "6px", alignItems: "center" }}>
              <label style={{ fontFamily: fontConfig.EventsEventDetailsTextFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 }}>
                Add Contact Tags
              </label>
              <InfoTooltip text='Automatically add selected tags to a contact after event registration is submitted or once a "Bill My Account" charge is paid. Example: Add a "Passover 2026" tag when someone registers to the event.' />
            </div>
            <div className="event_tags">
            {formik.values?.eventDetails?.tags?.length > 0 && formik.values?.eventDetails?.tags?.sort((a, b) => a?.toLowerCase().localeCompare(b?.toLowerCase())).map((tag, i) => {
              return (
                <span className="event_tag" key={tag}>
                  {tag}
                  <span
                    style={{
                      marginLeft: '5px',
                      fontSize: '12px',
                      fontWeight: '400',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      deleteTag(tag);
                    }}
                  >
                    x
                  </span>
                </span>
              );
            })}
            <div className="event_add-tag">
              <span
                style={{
                  color: '#B5B5C3',
                  fontFamily: fontConfig.EventsEventDetailsTextFont.family,
                  fontWeight: '500',
                  fontSize: '13px',
                  textAlign: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => setOpenTag(true)}
              >
                <strong>+</strong> Add a tag
              </span>
            </div>
            </div>
          </Col>
        </Row>
        <div className="tag_modal">
          <Dialog
            open={openTag}
            onClose={() => {
              setOpenTag(false);
            }}
            PaperProps={{
              style: {
                background: "#fff",
                borderRadius: "10px",
              },
            }}
          >
            <AddNewTag
              setOpenTag={setOpenTag}
              openTag={openTag}
              addTagHandler={(tag) => {
                formik.setFieldValue('eventDetails.tags', [...formik.values?.eventDetails?.tags, tag]);
              }}
              deleteTagHandler={(tag) => {
                const filteredTags = formik.values?.eventDetails?.tags?.filter(
                  (item) => item !== tag
                );
                formik.setFieldValue('eventDetails.tags', filteredTags);
              }}
              selectedUserTag={formik.values?.eventDetails?.tags || []}
              type="event"
              apiType="contact"
            />
          </Dialog>
        </div>
        <Row style={{ marginBottom: '40px', marginTop: '20px' }}>
          <Col className="col-sm-12">
            <div className="d-flex" style={{ gap: "6px", alignItems: "center", marginBottom: '8px' }}>
              <label style={{ fontFamily: fontConfig.EventsEventDetailsTextFont.family, fontWeight: '500', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 }}>
                Add Account Tags
              </label>
              <InfoTooltip text='Automatically add selected tags to an account after event registration is submitted or once a "Bill My Account" charge is paid. Example: Add a "Passover 2026" tag to the account when someone registers to the event.' />
            </div>
            <div className="event_tags">
              {formik.values?.eventDetails?.accountTags?.length > 0 && [...formik.values.eventDetails.accountTags].sort((a, b) => a?.toLowerCase().localeCompare(b?.toLowerCase())).map((tag) => (
                <span className="event_tag" key={tag}>
                  {tag}
                  <span
                    style={{ marginLeft: '5px', fontSize: '12px', fontWeight: '400', cursor: 'pointer' }}
                    onClick={() => formik.setFieldValue('eventDetails.accountTags', formik.values.eventDetails.accountTags.filter((t) => t !== tag))}
                  >
                    x
                  </span>
                </span>
              ))}
              <div className="event_add-tag">
                <span
                  style={{ color: '#B5B5C3', fontFamily: fontConfig.EventsEventDetailsTextFont.family, fontWeight: '500', fontSize: '13px', textAlign: 'center', cursor: 'pointer' }}
                  onClick={() => setOpenAccountTag(true)}
                >
                  <strong>+</strong> Add a tag
                </span>
              </div>
            </div>
          </Col>
        </Row>
        <div className="tag_modal">
          <Dialog
            open={openAccountTag}
            onClose={() => setOpenAccountTag(false)}
            PaperProps={{ style: { background: "#fff", borderRadius: "10px" } }}
          >
            <AddNewTag
              setOpenTag={setOpenAccountTag}
              openTag={openAccountTag}
              addTagHandler={(tag) => {
                formik.setFieldValue('eventDetails.accountTags', [...(formik.values?.eventDetails?.accountTags || []), tag]);
              }}
              deleteTagHandler={(tag) => {
                formik.setFieldValue('eventDetails.accountTags', (formik.values?.eventDetails?.accountTags || []).filter((t) => t !== tag));
              }}
              selectedUserTag={formik.values?.eventDetails?.accountTags || []}
              type="event"
              apiType="account"
            />
          </Dialog>
        </div>
      </>}
    </>
  );
};

export default ClassDetails;